import { render, staticRenderFns } from "./ThemePickerIcon.vue?vue&type=template&id=34faf0e3&"
import script from "./ThemePickerIcon.vue?vue&type=script&lang=js&"
export * from "./ThemePickerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports